import clsx from 'clsx'
import React from 'react'

import { Icon } from '@wartek-id/icon'

import type { IImage } from './typings'

// To make sure tailwind scan aspectRatio config, this mapping must be defined
const aspect = {
  'aspect-auto': 'aspect-auto',
  'aspect-3/1': 'aspect-3/1',
  'aspect-2/1': 'aspect-2/1',
  'aspect-square': 'aspect-square',
} as const

/** Base widget without craftjs */
export const BaseWidget = React.forwardRef<
  HTMLDivElement,
  IImage & { className?: string }
>(({ altText = 'image_widget', imageUrl, ratio, className }, ref) => {
  const aspectRatio = aspect[ratio]
  return (
    <div
      ref={ref}
      className={clsx('widget-component mb-2 last:mb-0', className)}
    >
      {!!imageUrl ? (
        <img
          alt={altText}
          src={imageUrl}
          className={clsx(
            aspectRatio,
            'object-cover object-center w-full',
            'rounded border border-subdued'
          )}
        />
      ) : (
        <div
          className={clsx(
            aspectRatio,
            'grid place-items-center !bg-gray-30 !min-h-[60px]',
            'rounded border border-subdued'
          )}
        >
          <Icon>image</Icon>
        </div>
      )}
    </div>
  )
})
BaseWidget.displayName = 'Image'

export default BaseWidget
